import * as Sentry from '@sentry/react';

export const captureError = (err, hint = {}) => {
  console.error(err);
  Sentry.captureException(err, hint);
};
